import axios from 'axios';
import { getAuth } from '../providers/AppAuthProvider';
import { API_BASE_URL as baseUrl } from 'src/utils/api-url';

const base = 'xbit-relay';

async function authHeaders() {
  const { accessToken } = (await getAuth()) || {};
  return {
    Authorization: `Bearer ${accessToken}`,
    Accept: 'application/json',
  };
}

// Reuse provider/hot-wallet helpers and types from the sibling service.
export {
  listProviders,
  listHotWallets,
} from './xbitRelayService';
export type { ProviderItem, HotWalletItem } from './xbitRelayService';

export type SweepLatestStatus = '' | 'PROCESSING' | 'SUCCESS' | 'FAILED' | 'SKIPPED';

export type SweepWalletItem = {
  address: string;
  chainId: number;
  userId: string;
  provider: string;
  token: string;
  symbol: string;
  decimals: number;
  balance: string;
  latestStatus: SweepLatestStatus | string;
  lastActiveUnixMs: string;
};

export type SweepWalletFilters = {
  page?: number;
  pageSize?: number;
  userId?: string;
  provider?: string;
  chainId?: number;
  address?: string;
  hideZeroBalance?: boolean;
  orderBy?: 'lastActive' | 'balance';
  orderDirection?: 'ASC' | 'DESC';
};

export type ListSweepWalletsResponse = {
  items: SweepWalletItem[];
  total: string;
  page: number;
  pageSize: number;
};

export async function listSweepWallets(filters: SweepWalletFilters = {}) {
  const headers = await authHeaders();
  const params: Record<string, string> = {};
  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    params[key] = String(value);
  });
  return axios.get<ListSweepWalletsResponse>(`${baseUrl}/${base}/sweep/wallets`, {
    headers,
    params,
  });
}

export type CollectBody = {
  address: string;
  chainId: number;
  token: string;
  idempotencyKey?: string;
};

export type CollectResponse = {
  success: boolean;
  message: string;
  collectLogId?: string;
  duplicate?: boolean;
};

export async function collectSweep(body: CollectBody) {
  const headers = await authHeaders();
  return axios.post<CollectResponse>(`${baseUrl}/${base}/sweep/collect`, body, {
    headers,
  });
}

export type IncidentSweepBody = {
  provider: string;
};

export type IncidentSweepResponse = {
  success: boolean;
  message: string;
};

export async function incidentSweep(body: IncidentSweepBody) {
  const headers = await authHeaders();
  return axios.post<IncidentSweepResponse>(`${baseUrl}/${base}/sweep/incident`, body, {
    headers,
  });
}

export type SweepHistoryStatus = 'PROCESSING' | 'SUCCESS' | 'FAILED' | 'SKIPPED';

export type SweepHistoryItem = {
  id: string;
  userId: string;
  provider: string;
  chainId: number;
  address: string;
  token: string;
  symbol: string;
  amount: string;
  status: SweepHistoryStatus | string;
  txHash: string;
  preConditionTxid: string;
  postConditionTxid: string;
  errorMsg: string;
  collectTimeUnixMs: string;
};

export type SweepHistoryFilters = {
  page?: number;
  pageSize?: number;
  userId?: string;
  provider?: string;
  chainId?: number;
  address?: string;
};

export type ListSweepHistoryResponse = {
  items: SweepHistoryItem[];
  total: string;
  page: number;
  pageSize: number;
};

export async function listSweepHistory(filters: SweepHistoryFilters = {}) {
  const headers = await authHeaders();
  const params: Record<string, string> = {};
  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    params[key] = String(value);
  });
  return axios.get<ListSweepHistoryResponse>(`${baseUrl}/${base}/sweep/history`, {
    headers,
    params,
  });
}
